module.exports = __webpack_public_path__ + "img/pr-1.25527bb0.png";